import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import { useGetLmsNewsPhotoQuery } from '../../../../api';
import { isAnnouncement } from '../utils/newsUtils';

const PLACEHOLDER_BACKGROUND = {
    training: 'linear-gradient(135deg, #1E2A5A 0%, #2F3F86 100%)',
    announcement: 'linear-gradient(135deg, #3A2A12 0%, #6B4A1F 100%)'
};

const LmsNewsPhoto = ({ news, style, className = '', children }) => {
    const hasPhoto = !!(news?.id && news?.photoDocumentId);
    const { data: photoUrl, isFetching, isError } = useGetLmsNewsPhotoQuery({ newsId: news?.id, fileKey: news?.photoFileKey }, { skip: !hasPhoto });
    const announcement = isAnnouncement(news);

    const showImage = hasPhoto && photoUrl && !isError;

    return (
        <div
            className={`relative overflow-hidden flex align-items-center justify-content-center ${className}`.trim()}
            style={{ background: showImage ? '#F2F4F7' : PLACEHOLDER_BACKGROUND[announcement ? 'announcement' : 'training'], ...style }}
        >
            {hasPhoto && isFetching && !photoUrl && <Skeleton width="100%" height="100%" className="absolute top-0 left-0" borderRadius="0" />}
            {showImage ? (
                <img src={photoUrl} alt="" className="w-full h-full" style={{ objectFit: 'cover', display: 'block' }} />
            ) : (
                !isFetching && <i className={`pi ${announcement ? 'pi-megaphone' : 'pi-book'}`} style={{ fontSize: '2.25rem', color: 'rgba(255,255,255,0.75)' }} />
            )}
            {children}
        </div>
    );
};

export default LmsNewsPhoto;
